import React, { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { styles } from "assets/jss/default/views/errorPageStyles";
import { useTrackPageView } from "hooks/useTrackPageView";
import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";
import { Button, Grid } from "@mui/material";

const useStyles = makeStyles(styles);

export default function NoAccess() {
  const { logout } = useContext(CognitoAuthContext);
  useTrackPageView("No Access");
  const classes = useStyles();

  const supportEmailProps = {
    address: "support@onyxinsight.com",
    subject: "AI-Hub support query",
    body:
      "Please detail your problem or feedback here. If you have encountered a problem, please detail the actions you took leading up to the problem if possible:"
  };

  const supportEmailLink = `mailto:${
    supportEmailProps.address
  }?subject=${encodeURIComponent(
    supportEmailProps.subject
  )}&body=${encodeURIComponent(supportEmailProps.body)}`;

  const onLogout = () => {
    logout();
  };

  return (
    <div className={classes.contentCenter}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <h1 className={classes.title}>404</h1>
          <h2 className={classes.subTitle}>
            You don't have permission to view this page.
          </h2>
          <p className={classes.description}>
            You do not have the required permissions to view this page. If you
            believe this is an error, please contact your system administrator.
            Alternatively, please <a href={supportEmailLink}>contact support</a>
            .
          </p>
          <p>
            <Button onClick={onLogout}>Logout</Button>
          </p>
        </Grid>
      </Grid>
    </div>
  );
}
